import { render, staticRenderFns } from "./AdsetSummary.vue?vue&type=template&id=e3dc27d0&lang=pug"
import script from "./AdsetSummary.js?vue&type=script&lang=js&external"
export * from "./AdsetSummary.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports